import React, { PureComponent } from 'react';
import LogInFormContainer from '../components/logIn/LogInFormContainer';

export default class LogIn extends PureComponent {
  render() {
    return (
      <div className="page-wrapper login-page sign-in">
        <div className="block image-box">
          <div className="background-image" />
          <div className="background-title">
            <div className="background-highlight">Start Developers Portal</div>
            <div className="background-highlight full-width">Welcome Back</div>
            <div className="background-text">
              Start Magazine is a revolutionary CaaS (content as a service)
              solution that helps drive up engagement in any app and every
              language.
            </div>
          </div>
        </div>
        <div className="block content-wrapper">
          <div>
            <LogInFormContainer />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LogIn.js